/** Worker Sagas */

import { apiClient, applyHeaders, buildHeaders } from "@bkry/bowline-utils";
import { call, put, takeEvery, select } from "redux-saga/effects";
import { storeIncluded } from "../dictionarySagas";
import { actions } from "./index";

export function* list(action) {
  const locale = yield select((state) => state.i18nState.lang);
  let headers = yield buildHeaders(locale);
  let { projectId, pageNum, itemNum, sorting, filters } =
    action.payload;
  try {
    const SwaggerClient = yield call(apiClient);
    const payload = yield call(
      SwaggerClient.apis.ProjectOrders.listProjectOrdersForProject,
      {
        project_id: projectId,
        page: pageNum,
        items: itemNum,
        sorting: JSON.stringify(sorting),
        filters: JSON.stringify(filters),
      },
      {
        requestInterceptor: applyHeaders(headers),
      }
    );
    if (payload.obj.included)
      yield* storeIncluded({ payload: payload.obj.included });
    yield put(
      actions.listSuccess({ ...payload })
    );
  } catch (e) {
    yield put(actions.listFail({ message: e.message, ...e }));
  }
}

function* projectOrdersSaga() {
  yield takeEvery(actions.list, list);
}
export default projectOrdersSaga;
